import React, { useState } from "react";
import { AxiosGraphQlAction } from "../../../services";
import Loader from "../loader";

interface Props {
    title: string;
    id: string;
    query: string;
    onDeleteAction?: any;
}

function Delete(props: Props) {
    const { title, id, query, onDeleteAction } = props;

    const [loading, setLoading] = useState(false);

    const submitAction = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true);

        const deleteConfirm = e.currentTarget.deleteConfirm.value;
        const ID = e.currentTarget.deleteID.value;
        const variables = {
            id: ID,
        };

        if (ID && deleteConfirm.toLocaleLowerCase() === "confirm") {
            AxiosGraphQlAction(variables, query).then(() => {
                onDeleteAction?.();
                window.location.reload();
            });
        } else {
            setLoading(false);
            alert("Type CONFIRM to delete");
        }
    };

    return (
        <div className="positon-relative">
            {loading && <Loader />}
            <div className="cmp-delete">
                <h5 className="cmp-delete__title">
                    Are you sure you want to delete this {title}?
                    <br />
                    If yes then enter CONFIRM into the box.
                </h5>

                <form
                    className="form-inline"
                    onSubmit={(e) => {
                        submitAction(e);
                    }}
                >
                    <div className="form-group mr-sm-3 mb-2">
                        <input
                            name="deleteConfirm"
                            type="text"
                            className="form-control mb-0"
                            placeholder="CONFIRM"
                        />
                        <input name="deleteID" type="hidden" value={id} />
                    </div>
                    <button type="submit" className="btn btn-danger mb-2">
                        Delete {title}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default Delete;
